import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PaginationState {
  currentPage: number;
}

const initialState: PaginationState = {
  currentPage:0
};

const orphanPaginationSlice = createSlice({
  name: 'orphanPaginationSlice',
  initialState,
  reducers: {
    setCurrentPageData: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    resetPagination: (state) => {
      state.currentPage = 1;
    },
  },
});

export const { setCurrentPageData, resetPagination } = orphanPaginationSlice.actions;
export default orphanPaginationSlice.reducer;